import React from 'react'
import CardLayout from '../../../../components/layouts/CardLayout'
import { Text } from '../../../../modules/Dashboard'
import PredictHistoryWidget from '../History/ai-hist/PredictHistoryWidget'

const AnalysisHistory = () => {
    return (
        <CardLayout className="!h-full !p-0 !border-none">
            <PredictHistoryWidget />
        </CardLayout>
    )
}

export default AnalysisHistory